import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const StatesStyled = styled.div`
  .sectionThird {
    display: flex;
    flex-direction: column;
    gap: 16px;

    & h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.4;
      color: ${color.text.primary};
      margin: 0;
    }

    & p {
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5;
      color: ${color.text.tertiary};
      margin: 0;
    }
  }

  .sectionHeader {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .formField {
    display: flex;
    flex-direction: column;

    label {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      color: ${color.text.label};
      margin-bottom: 8px;
      ::after {
        content: '*';
        color: ${color.error.main};
        padding-left: 2px;
      }
    }
  }

  .notificationField {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 14px;
    color: ${color.text.secondary};
  }

  .notificationSwitch {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Alineado con el texto del switch */
  .notificationMethods {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-left: 66px;
  }

  /* Aviso de plantilla: el icono no se encoge con el texto en dos líneas */
  .notificationInfo {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 8px;
    background: ${tokens.color.background.light};

    svg {
      flex-shrink: 0;
      margin-top: 1px;
    }
  }

  .notificationRadios {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .MuiFormControlLabel-root {
      margin: 0;
    }
    .MuiTypography-body1 {
      font-family: ${tokens.typography.fontFamily.primary};
      font-size: 14px;
      color: ${color.text.secondary};
    }
  }

  .containerButtonForm {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .containerDragAndDropList {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .MuiCircularProgress-root {
    width: 24px !important;
    height: 24px !important;
  }
`
